import React, { useEffect, useRef, useState } from 'react';
import { Flex } from 'lib/components/styles/layout';
import { ILandingPageDesignResponse } from '../../../types';
import {
  BodyContainer,
  CtaButton,
  GradientOverlay,
  StyledBackgroundImage,
  VideoPlayerImage,
} from './styles';
import videoPlayerImage from '../../../assets/videoPlayerNoLogo.png';

interface IBodyProps {
  landingPageDesign: ILandingPageDesignResponse;
}

const ctaButtons = ['Get Started Free', 'Start Your Free Trial', 'Watch Demo'];

export const Body = ({ landingPageDesign }: IBodyProps) => {
  const refs = useRef<HTMLButtonElement[]>([]);
  const [width, setWidth] = useState<number>();

  const {
    bodyBackgroundColor,
    bodyBackgroundImage,
    buttonFontCase,
    buttonFontWeight,
    buttonFontFamily,
    buttonFontSize,
    buttonCornerRadius,
    buttonPaddingY,
    buttonPaddingX,
    buttonColor,
    buttonBorderColor,
    buttonBorderHoverColor,
    buttonTextColor,
    buttonTextHoverColor,
    showButtonBorder,
    buttonHoverColor,
    showGradient,
    gradient,
    bodyOrientation,
  } = landingPageDesign;

  useEffect(() => {
    // Determine the width of the widest button so all buttons
    // can maintain a consistent minimum width
    const maxWidth = Math.max(...refs.current.map(btn => btn.offsetWidth));
    setWidth(maxWidth);
  }, []);

  return (
    <BodyContainer
      bodyBackgroundColor={bodyBackgroundColor}
      bodyBackgroundImage={bodyBackgroundImage}
      bodyOrientation={bodyOrientation}
    >
      {bodyBackgroundImage && (
        <StyledBackgroundImage
          src={bodyBackgroundImage}
          alt='background-img-thumbnail-preview'
          bodyOrientation={bodyOrientation}
        />
      )}
      {!!showGradient && <GradientOverlay gradient={gradient} />}
      <Flex
        maxWidth='115px'
        gap={'4px'}
        alignItems='center'
        style={{ zIndex: 1 }}
      >
        <VideoPlayerImage src={videoPlayerImage} />
        <Flex
          justifyContent='center'
          flexDirection='row'
          flexWrap='wrap'
          gap='2px'
          width='100%'
        >
          {ctaButtons.map((buttonText, index) => (
            <CtaButton
              ref={el => (refs.current[index] = el!)}
              style={{ minWidth: width }}
              key={index}
              buttonFontCase={buttonFontCase}
              buttonFontWeight={buttonFontWeight}
              buttonFontFamily={buttonFontFamily}
              buttonFontSize={buttonFontSize}
              buttonCornerRadius={buttonCornerRadius}
              buttonPaddingY={buttonPaddingY}
              buttonPaddingX={buttonPaddingX}
              buttonColor={buttonColor}
              buttonHoverColor={buttonHoverColor}
              buttonBorderColor={buttonBorderColor}
              buttonBorderHoverColor={buttonBorderHoverColor}
              showButtonBorder={showButtonBorder}
              buttonTextColor={buttonTextColor}
              buttonTextHoverColor={buttonTextHoverColor}
            >
              {buttonText}
            </CtaButton>
          ))}
        </Flex>
      </Flex>
    </BodyContainer>
  );
};
